<template>
  <div class="footer">
    <div class="footer-content">
      <el-row  align="top" class="footer-row">
        <!-- Лого хэсэг -->
        <el-col :xs="24" :sm="24" :md="5" :lg="5" :xl="5" class="footer-logo" :offset="3">
          <img @click="goToHome('/')" src="@/assets/tenger_logo.png" alt="Logo" class="logo" /><br><br><br>
        </el-col>

        <!-- Холбоосууд -->
        <el-col :xs="24" :sm="24" :md="5" :lg="5" :xl="5" class="footer-links" :offset="2">
          <ul>
            <li><a href="#">Бидний тухай</a></li>
            <li><a @click="goToTermsOfService('/termsOfService')">Үйлчилгээний нөхцөл</a></li>
            <li><a href="#">Нууцлалын бодлого</a></li>
            <li class="cursor"><a @click="goToAddress('/branches')">Холбоо барих</a></li>
          </ul><br>
        </el-col>

        <!-- Холбоо барих -->
        <el-col :xs="24" :sm="24" :md="5" :lg="5" :xl="5" class="footer-contact" :offset="2">
          <p>
            <a target="_blank" class="text_color_white" href="https://www.facebook.com/share/1CtacEwq66/?mibextid=wwXIfr"><i class="fa-brands fa-square-facebook"></i>Тэнгэр карго Tenger cargo</a>
          </p>
          <p>
            <a target="_blank" class="text_color_white" href="https://www.instagram.com/tenger_cargo?igsh=MTMwdzl4OWZyZzJyMw=="><i class="fa-brands fa-instagram"></i>Тэнгэр карго | Tenger cargo</a>
          </p>
          <p><a href="tel:+97680056089" class="text_color_white"><i class="fa-solid fa-phone"></i>+976 7272-1280</a></p>
          <p><a href="mailto:tengerb2b@gmail.com" class="text_color_white"><i class="fa-regular fa-envelope"></i>tengerb2b@gmail.com</a></p>
        </el-col>
      </el-row>
    </div>
    <div class="footer-bottom">
      <p>&copy;Copyright 2025 <span class="title_color"> &nbsp; Эй энд Зэт Консалтинг ХХК</span></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterComponent',
  data () {
    return {
      windowWidth: window.innerWidth
    }
  },
  methods: {
    handleResize () {
      this.windowWidth = window.innerWidth
    },
    goToAddress (url) {
      if (this.$route.path !== url) {
        this.$router.push('/branches')
      }
    },
    goToHome (url) {
      if (this.$route.path !== url) {
        this.$router.push('/')
      }
    },
    goToTermsOfService (url) {
      if (this.$route.path !== url) {
        this.$router.push('/termsOfService')
      }
    }
  },
  mounted () {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>

<style>
.footer {
  background-color: #0c265c;
  color: white;
  font-family: 'Geologica', sans-serif;
}

.footer-content {
  padding: 40px 20px;
  line-height: 2;
}

.footer-row {
  /* max-width: 1200px; */
  margin: 0 auto;
}

.footer-logo {
  text-align: left;
}

.footer-logo .logo {
  width: 150px;
}

.footer-links ul {
  list-style: none;
  padding: 0;
}

.footer-links li {
  margin-bottom: 10px;
}

.footer-links a {
  color: white;
  text-decoration: none;
  font-size: 14px;
}

.footer-links a:hover {
  text-decoration: underline;
}

.footer-contact p {
  margin: 10px 0;
  font-size: 14px;
}

.footer-contact i {
  margin-right: 10px;
}

.footer-bottom {
  background-color: #091c40;
  text-align: center;
  padding: 10px 0;
  font-size: 12px;
}
.title_color{
    color: #a4b9d2;
  }
</style>
